import DataTableComponent from 'react-data-table-component';
import { Card } from 'reactstrap';
import DataTableProgress from './DataTableProgress';

type DataTableProps = {
  title?: string;
  columns: any[];
  data: any[];
  totalRows: number;
  loading: boolean;
  button?: boolean;
  buttonUrl?: string;
  settingsButton?: boolean;
  filtersList?: any[];
  conditionalRowStyles?: any[];
  onChangeRowsPerPage?: (perPage: number, page: number) => Promise<void>;
  onChangePage?: (page: number) => Promise<void>;
  onChangeFilter?: (filter: string) => void;
  onClickSettings?: () => void;
  fixedHeader?: boolean;
  fixedHeaderScrollHeight?: string;
  compact?: boolean;
};

const DataTableWithoutHeader = ({
  columns,
  data,
  totalRows,
  loading,
  onChangeRowsPerPage,
  onChangePage,
  conditionalRowStyles,
  fixedHeader,
  fixedHeaderScrollHeight,
  compact = false,
}: DataTableProps) => {
  const cellPadding = compact ? '0.5rem' : '1.5rem';
  const rowMinHeight = compact ? '48px' : '65px';
  const customStyles: any = {
    table: {
      style: {},
    },
    header: {
      style: {
        borderRadius: 'calc(0.375rem - 1px) calc(0.375rem - 1px) 0 0',
        minHeight: '65px',
        fontSize: '1.0625rem',
        fontWeight: '900',
        lineHeight: '1.5',
      },
    },
    headCells: {
      style: {
        paddingLeft: cellPadding,
        paddingRight: cellPadding,
        background: '#F6F9FC',
        color: '#8898aa',
        fontSize: '0.65rem',
        paddingTop: '0.75rem',
        paddingBottom: '0.75rem',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        verticalAlign: 'middle',
        fontWeight: '600',
      },
    },
    rows: {
      style: {
        minHeight: rowMinHeight,
        fontSize: '0.8125rem',
        verticalAlign: 'middle',
        color: '#525f7f',
      },
    },
    cells: {
      style: {
        paddingLeft: cellPadding,
        paddingRight: cellPadding,
        paddingTop: '0.5rem',
        paddingBottom: '0.5rem',
        fontSize: '0.8125rem',
        whiteSpace: 'normal',
        overflowWrap: 'break-word',
      },
    },
  };

  return (
    <>
      {compact && (
        <style>{`
          .dt-compact-wrapper .rdt_TableBody,
          .dt-compact-wrapper .rdt_Table {
            scrollbar-width: thin;
            scrollbar-color: #cbd5e1 transparent;
          }
          .dt-compact-wrapper .rdt_TableBody::-webkit-scrollbar,
          .dt-compact-wrapper .rdt_Table::-webkit-scrollbar,
          .dt-compact-wrapper [data-tag="allowRowEvents"]::-webkit-scrollbar,
          .dt-compact-wrapper > div::-webkit-scrollbar {
            height: 8px;
            width: 8px;
          }
          .dt-compact-wrapper *::-webkit-scrollbar {
            height: 8px;
            width: 8px;
          }
          .dt-compact-wrapper *::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }
          .dt-compact-wrapper *::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }
          .dt-compact-wrapper *::-webkit-scrollbar-track {
            background: transparent;
          }
        `}</style>
      )}
      <Card className={`dt-thin-scroll shadow ${compact ? 'dt-compact-wrapper' : ''}`}>
        <DataTableComponent
          customStyles={customStyles}
          columns={columns}
          data={data}
          progressPending={loading}
          progressComponent={<DataTableProgress />}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          conditionalRowStyles={conditionalRowStyles}
          fixedHeader={fixedHeader}
          fixedHeaderScrollHeight={fixedHeaderScrollHeight}
        />
      </Card>
    </>
  );
};

export default DataTableWithoutHeader;
